import { ServiceTypeMedium } from '~/features/appointment-invites/types'

const mediums = ['physical', 'voice', 'video'] as const
export type InviteMedium = typeof mediums[number]

export const isInviteMedium = (
  value?: string | null
): value is ServiceTypeMedium =>
  value ? (mediums as readonly string[]).includes(value) : false
